export * from './MaterialsCopyLinkButton.type';
export { default as MaterialsCopyLinkButton } from './MaterialsCopyLinkButton';
